module.exports = __webpack_public_path__ + "static/media/39_B.d99df37f.png";